import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

var basicAction = function basicAction(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? null : _ref$size,
      _ref$extraTight = _ref.extraTight,
      extraTight = _ref$extraTight === void 0 ? false : _ref$extraTight,
      _ref$tight = _ref.tight,
      tight = _ref$tight === void 0 ? false : _ref$tight,
      _ref$base = _ref.base,
      base = _ref$base === void 0 ? false : _ref$base,
      _ref$bitLoose = _ref.bitLoose,
      bitLoose = _ref$bitLoose === void 0 ? false : _ref$bitLoose,
      _ref$loose = _ref.loose,
      loose = _ref$loose === void 0 ? false : _ref$loose,
      _ref$extraLoose = _ref.extraLoose,
      extraLoose = _ref$extraLoose === void 0 ? false : _ref$extraLoose,
      _ref$superLoose = _ref.superLoose,
      superLoose = _ref$superLoose === void 0 ? false : _ref$superLoose;
  var cssModifier = [];
  if (size) cssModifier.push("".concat(size)); // Size as Flag

  if (extraTight) cssModifier.push('size-extra-tight');else if (tight) cssModifier.push('size-tight');else if (base) cssModifier.push('size-base');else if (bitLoose) cssModifier.push('size-bit-loose');else if (loose) cssModifier.push('size-loose');else if (extraLoose) cssModifier.push('size-extra-loose');else if (superLoose) cssModifier.push('size-super-loose');
  return cssModifier;
};

var instance = [basicAction];

var pipe = function pipe() {
  return {
    getInstance: function getInstance() {
      return instance;
    },
    add: function add(customModifier) {
      instance.push(customModifier);
    },
    execute: function execute(props) {
      return instance.reduce(function (temp, action) {
        return [].concat(_toConsumableArray(temp), _toConsumableArray(action(props)));
      }, []);
    }
  };
};

export default pipe;
//# sourceMappingURL=convertPropsToSizeModifiers.js.map
